import Vue from 'vue'
import Vuex from 'vuex'
import { getMetricsData } from '@/services/performance'

Vue.use(Vuex)

const state = {
  dates: [],
  metricsData: {},
  currentSelectedTab: 'accuracy',
  currentSelectedAlgoRule: '',
  modelsVisibility: {},
  chartName: '',
  dateChange: false,
  getDeployDialogStatus: false
}

const modules = {}

const getters = {
  currentSelectedTab: state => state.currentSelectedTab,
  metricsData: state => state.metricsData,
  currentSelectedAlgoRule: state => state.currentSelectedAlgoRule,
  modelsVisibility: state => state.modelsVisibility,
  chartName: state => state.chartName,
  dates: state => state.dates,
  dateChange: state => state.dateChange,
  getDeployDialogStatus: state => state.getDeployDialogStatus
}

const mutations = {
  setSingleProperty: (state, [prop, value]) => {
    state[prop] = value
  },
  setChartData: (state, [prop, timeSlot, value]) => {
    state[prop][timeSlot] = value
  },
  setModelsVisibility: (state, [prop, modelName, visibility]) => {
    state[prop][modelName] = visibility
  },
  setChartName: (state, [prop, chartName]) => {
    state[prop] = chartName
  },
  setDateChange: (state, [prop, dateChange]) => {
    state[prop] = dateChange
  }
}
const metricsData = {}

const actions = {
  setCurrentSelectedTab: ({ commit }, tabKey) => {
    commit('setSingleProperty', ['currentSelectedTab', tabKey])
  },
  setCurrentSelectedTimeSlot: ({ commit }, timeSlot) => {
    commit('setSingleProperty', ['currentSelectedTimeSlot', timeSlot])
  },
  setCurrentSelectedAlgoRule: ({ commit }, algoRule) => {
    commit('setSingleProperty', ['currentSelectedAlgoRule', algoRule])
  },
  setModelsVisibility: ({ commit }, { modelName, visibility }) => {
    commit('setModelsVisibility', ['modelsVisibility', modelName, visibility])
  },
  setChartName: ({ commit }, { chartName }) => {
    commit('setChartName', ['chartName', chartName])
  },
  setDateChange: ({ commit }, { dateChange }) => {
    commit('setDateChange', ['dateChange', dateChange])
  },
  setDates: ({ commit }, dates) => {
    commit('setSingleProperty', ['dates', dates])
  },
  async fetchAndUpdateChartData({ commit, state }, chartName) {
    if (!state.metricsData[chartName] || state.dateChange) {
      metricsData[chartName] = await getMetricsData(state, chartName)
    }
    commit('setSingleProperty', ['metricsData', metricsData])
  },
  setDeployDialogStatus: ({ commit }, state) => {
    commit('setSingleProperty', ['getDeployDialogStatus', state])
  }
}

const namespaced = true

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
  modules
}
